export default __webpack_public_path__ + "static/media/G-2.3dfdcbbb.svg";